import React, { useState } from "react";
import "./PasswordGate.css";

const CORRECT_PASSWORD = "TectraPricing2025";

function PasswordGate({ onAuthenticated }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (password === CORRECT_PASSWORD) {
      // Store authentication in sessionStorage (cleared when browser closes)
      sessionStorage.setItem("tectra_authenticated", "true");
      onAuthenticated();
    } else {
      setError(true);
      setPassword("");
      setTimeout(() => setError(false), 3000);
    }
  };

  return (
    <div className="password-gate">
      <div className="password-gate-container">
        <div className="password-gate-header">
          <img src="/icon.svg" alt="Tectra" className="password-logo" />
          <h1>Tectra Pricing Calculator</h1>
          <p className="password-subtitle">Limited Access</p>
        </div>

        <form onSubmit={handleSubmit} className="password-form">
          <div className="password-input-group">
            <label htmlFor="password">Enter Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className={`password-input ${error ? "error" : ""}`}
              autoFocus
            />
            {error && (
              <p className="error-message">
                Incorrect password. Please try again.
              </p>
            )}
          </div>

          <button type="submit" className="password-submit-btn">
            Access Calculator
          </button>
        </form>

        <div className="password-footer">
          <p>For access, please contact Tectra</p>
        </div>
      </div>
    </div>
  );
}

export default PasswordGate;
